import { render, staticRenderFns } from "./order-evaluate.vue?vue&type=template&id=2499a575&scoped=true"
import script from "./order-evaluate.vue?vue&type=script&lang=ts"
export * from "./order-evaluate.vue?vue&type=script&lang=ts"
import style0 from "./order-evaluate.vue?vue&type=style&index=0&id=2499a575&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2499a575",
  null
  
)

export default component.exports